module.exports = __webpack_public_path__ + "static/img/868_phase_function_Paper_Points.40749c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/868_phase_function_Paper_Points.png
// module id = pG41
// module chunks = 0